import MineControl from "../control/MineControl";
import { MineModes } from "../control/MineModes";

export default class MineControlSave {
    constructor() {
    }

    /**
     * @param {MineControl} mineControl
     * @returns {Object}
     */
    static generateSave(mineControl) {
        const saveState = {};

        saveState.activeId = mineControl.activeMode.id;

        return saveState;
    }

    /**
     * @param {MineControl} mineControl 
     * @param {Object} saveState 
     */
    static loadSave(mineControl, saveState) {
        if (!saveState) {
            return;
        }

        const modeId = saveState.activeId;

        if (modeId) {
            mineControl.setActiveModeById(modeId);
        }
        else {
            console.log('MineControlSave.loadSave() Failed to load mine mode.');
            mineControl.setModeActive(MineModes.MINE_AUTO);
        }
    }
}